import {Fragment, useState} from "react";
import {Button, Col, Modal, Row} from "react-bootstrap";
import LoadingText from "../Loading/LoadingText";
import BootstrapTable from "react-bootstrap-table-next";
import cogoToast from "cogo-toast";
import appUtility from "../../RestAPI/AppUtility";
import {useSelector} from "react-redux";


export default function Contact(){
    let state=useSelector((state)=> state);
    const [DataCoEffeciant, setDataCoEffeciant]=useState([]);
    const [ColumnCoEfficient, setColumnCoEfficient]=useState([{}]);
    const [DataLength, setDatalength]=useState(0);
    const[DataStatus, setDataStatus]=useState(false);
    const selectRow={
        mode:'radio',
        onSelect:(row,isSelect,rowIndex)=>{

        }
    }
    return(
        <Fragment>
            <div >
                <Row className="mt-2">

                    <Col lg={3}>
                        <div className="">

                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Name</label></Col>
                                <Col lg={9}xs={8}>
                                    <input type="text" className="w-100" id="txtEmployeeName"/>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Designation</label></Col>
                                <Col lg={9}xs={8}>
                                    <select defaultValue={100} className="float-start w-100 customfontsize" id="cmbEmployeeDesignation"  >
                                        <option >All</option>
                                        <option >Member</option>
                                        <option >Commissioner</option>
                                        <option >ADC</option>
                                        <option >JC</option>
                                        <option >DC</option>
                                        <option >AC</option>
                                        <option >RO</option>
                                        <option >ARO</option>

                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Batch</label></Col>
                                <Col lg={9}xs={8}>
                                    <select defaultValue={100} className="float-start w-100 customfontsize" id="cmbEmployeeBatch"  >
                                        <option >All</option>
                                        <option >Cadar</option>
                                        <option >Non-Cadar</option>
                                        <option >Promotee</option>
                                        <option >Other</option>

                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Mobile</label></Col>
                                <Col lg={9}xs={8}>
                                    <input type="text" className="w-100" id="txtEmployeeMobile"/>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Data Limit</label></Col>
                                <Col lg={9}xs={8}>
                                    <select defaultValue={100} className="float-start w-100 customfontsize" id="cmbDataLimit"  >
                                        <option >All</option>
                                        <option >100</option>
                                        <option >200</option>
                                        <option >500</option>
                                        <option >1000</option>
                                        <option >2000</option>
                                        <option >3000</option>
                                        <option >5000</option>
                                        <option >10000</option>
                                        <option >20000</option>
                                        <option >50000</option>


                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-4">
                                <Col lg={3} >

                                </Col>
                                <Col lg={9} >
                                    <button className="w-100 text-danger" >Search</button>
                                </Col>


                            </Row>



                        </div>
                    </Col>

                    <Col lg={9}>
                        <div className="overflow-scroll animated zoomIn purchaseMediumDiv">
                            {
                                DataStatus? <LoadingText/>
                                    :<BootstrapTable selectRow={selectRow}  keyField='Id' data={DataCoEffeciant} columns={ColumnCoEfficient}></BootstrapTable>


                            }
                        </div>

                    </Col>
                    <label className="text-danger">Data found: {DataLength}</label>
                </Row>

            </div>

        </Fragment>
    );

}
